import api from './api';

// Importar constantes de cores para os gráficos

// Cores para os gráficos
export const COLORS = {
  primary: '#3f51b5',
  secondary: '#f50057',
  success: '#4caf50',
  warning: '#ff9800',
  error: '#f44336',
  info: '#2196f3',
  pending: '#ffeb3b',
  completed: '#4caf50',
  inProgress: '#ff9800',
  waiting: '#2196f3',
  scheduled: '#9c27b0',
  cancelled: '#757575'
};

// Interface para dados de chamados técnicos por status
export interface TechnicalRequestStats {
  name: string;
  value: number;
  color: string;
}

// Interface para dados de chamados comerciais por status
export interface CommercialVisitStats {
  name: string;
  value: number;
  color: string;
}

// Interface para dados de custo por mês
export interface CostByMonth {
  name: string;
  value: number;
}

// Interface para dados de forecast de custo
export interface CostForecast {
  name: string;
  actual: number | null;
  forecast: number;
}

// Mapeamento de status para cores
const statusColorMap: Record<string, string> = {
  'Finalizado': COLORS.completed,
  'Em Execução': COLORS.inProgress,
  'Aguardando': COLORS.waiting,
  'Agendada': COLORS.scheduled,
  'Em Andamento': COLORS.inProgress,
  'Concluída': COLORS.completed,
  'Cancelado': COLORS.cancelled,
  'Pendente': COLORS.pending
};

// Função para buscar estatísticas de chamados técnicos por status
export const getTechnicalRequestStats = async (): Promise<TechnicalRequestStats[]> => {
  try {
    console.log('Buscando estatísticas de chamados técnicos');
    const response = await api.get('/service-requests/stats');
    console.log('Resposta da API (chamados técnicos):', response.data);
    
    // Transformar os dados para o formato esperado pelo gráfico
    // Assumindo que a API retorna algo como { byStatus: { Finalizado: 35, "Em Execução": 25, Aguardando: 40 } }
    const formattedData = Object.entries(response.data.byStatus || {}).map(([name, value]) => ({
      name,
      value: value as number,
      color: statusColorMap[name] || COLORS.primary
    }));
    
    return formattedData;
  } catch (error) {
    console.error('Erro ao buscar estatísticas de chamados técnicos:', error);
    throw error;
  }
};

// Função para buscar estatísticas de chamados comerciais por status
export const getCommercialVisitStats = async (): Promise<CommercialVisitStats[]> => {
  try {
    console.log('Buscando estatísticas de chamados comerciais');
    const response = await api.get('/commercial-visits/stats');
    console.log('Resposta da API (chamados comerciais):', response.data);
    
    // Transformar os dados para o formato esperado pelo gráfico
    const formattedData = Object.entries(response.data.byStatus || {}).map(([name, value]) => ({
      name,
      value: value as number,
      color: statusColorMap[name] || COLORS.secondary
    }));
    
    return formattedData;
  } catch (error) {
    console.error('Erro ao buscar estatísticas de chamados comerciais:', error);
    throw error;
  }
};

// Função para buscar dados de custo por mês
export const getCostByMonth = async (): Promise<CostByMonth[]> => {
  try {
    console.log('Buscando dados de custo por mês');
    const response = await api.get('/service-requests/stats/costs');
    console.log('Resposta da API (custos por mês):', response.data);
    
    // Transformar os dados para o formato esperado pelo gráfico
    // Assumindo que a API retorna algo como { byMonth: { Jan: 12500, Fev: 18900, ... } }
    const formattedData = Object.entries(response.data.byMonth || {}).map(([name, value]) => ({
      name,
      value: value as number
    }));
    
    return formattedData;
  } catch (error) {
    console.error('Erro ao buscar dados de custo por mês:', error);
    throw error;
  }
};

// Função para buscar dados de forecast de custo
export const getCostForecast = async (): Promise<CostForecast[]> => {
  try {
    console.log('Buscando dados de forecast de custo');
    const response = await api.get('/service-requests/stats/forecast');
    console.log('Resposta da API (forecast de custo):', response.data);
    
    // Transformar os dados para o formato esperado pelo gráfico
    // Assumindo que a API retorna algo como { Jan: { actual: 12500, forecast: 13000 }, ... }
    const formattedData = Object.entries(response.data || {}).map(([name, data]: [string, any]) => ({
      name,
      actual: data.actual,
      forecast: data.forecast
    }));
    
    return formattedData;
  } catch (error) {
    console.error('Erro ao buscar dados de forecast de custo:', error);
    throw error;
  }
};

// Função para buscar todos os dados do dashboard de uma vez
export const getAllDashboardData = async () => {
  try {
    const [technicalStats, commercialStats, costData, forecastData] = await Promise.all([
      getTechnicalRequestStats(),
      getCommercialVisitStats(),
      getCostByMonth(),
      getCostForecast()
    ]);

    return {
      technicalStats,
      commercialStats,
      costData,
      forecastData
    };
  } catch (error) {
    console.error('Erro ao buscar dados do dashboard:', error);
    throw error;
  }
};
